/* DSA sectie C: voor/na-slider met versleepbare lijn (muis, touch, toetsenbord) */
if (!customElements.get('dsa-c-compare')) {
  class DsaCCompare extends HTMLElement {
    connectedCallback() {
      this.handle = this.querySelector('.dsa-cs__handle');
      this.frame = this.querySelector('.dsa-cs__frame');
      if (!this.handle || !this.frame) return;
      this.pos = 50;
      this.set(50);
      this.frame.addEventListener('pointerdown', (e) => {
        this.dragging = true;
        this.frame.setPointerCapture(e.pointerId);
        this.fromEvent(e);
        this.handle.focus({ preventScroll: true });
      });
      this.frame.addEventListener('pointermove', (e) => { if (this.dragging) this.fromEvent(e); });
      const stop = (e) => {
        this.dragging = false;
        if (this.frame.hasPointerCapture && this.frame.hasPointerCapture(e.pointerId)) this.frame.releasePointerCapture(e.pointerId);
      };
      this.frame.addEventListener('pointerup', stop);
      this.frame.addEventListener('pointercancel', stop);
      this.handle.addEventListener('keydown', (e) => {
        const step = e.shiftKey ? 10 : 2;
        if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') this.set(this.pos - step);
        else if (e.key === 'ArrowRight' || e.key === 'ArrowUp') this.set(this.pos + step);
        else if (e.key === 'Home') this.set(0);
        else if (e.key === 'End') this.set(100);
        else if (e.key === 'PageDown') this.set(this.pos - 10);
        else if (e.key === 'PageUp') this.set(this.pos + 10);
        else return;
        e.preventDefault();
      });
    }
    fromEvent(e) {
      const rect = this.frame.getBoundingClientRect();
      if (!rect.width) return;
      this.set(((e.clientX - rect.left) / rect.width) * 100);
    }
    set(value) {
      this.pos = Math.max(0, Math.min(100, value));
      this.style.setProperty('--dsa-pos', this.pos + '%');
      this.handle.setAttribute('aria-valuenow', Math.round(this.pos));
    }
  }
  customElements.define('dsa-c-compare', DsaCCompare);
}
